<router-outlet></router-outlet>
<p-toast position="top-right"></p-toast>
<ngx-spinner color = "#fff" size="medium" type = "ball-circus" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>